import React from 'react';
import LogoS from '../../../assets/images/logo-3d.png';
import './index.scss';





const Logo = () => {


  return (
    
      <img
        className="solid-logo"
        src={LogoS}
        alt="Software,  Developer"
      />
    
  )
}

export default Logo
